/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {
    DtpPanel
} from 'dtp-react-components';
import {
Grid,
SimpleGrid,
} from '../../../components/index';
import {DownloadArquivoMsg} from './DownloadArquivoMsg';
import {obterTipoMensagem} from './tiposMensagens';
import {formatarValor} from '../../../utils/helpers';

const rowStyle = {
    marginBottom: '13px',
    fontSize: '16px',
    textAlign: 'justify',
}  

const textoDestaque = texto =>(<span style={{fontWeight:'600'}}>{texto}</span>);

const PAGAMENTO_GRU_FORA_COMPREV = 'Pagamento efetuado fora do COMPREV (GPS ou GRU cobrança)';

// const formatarValor = (valor) => {
//     let valorFormatado = '0.0';
//     if (valor !== null) {
//         const formato = {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 3,
//         style: 'currency',
//         currency: 'BRL',        
//         };
//         valorFormatado = valor.toLocaleString('pt-BR', formato);
//     }
//     return valorFormatado;
// };

const montarTituloGru = (mensagem, grusTO) => {
    let retorno = '';
    if (mensagem.idGruNossoNumero && (grusTO && grusTO.length > 0)) {
        const index = grusTO.findIndex(gru => (gru.idGruNossoNumero === mensagem.idGruNossoNumero));
        if (index !== -1) {
            retorno = `${mensagem.idGruNossoNumero} gerada em ${grusTO[index].dataCriacao} com vencimento em ${grusTO[index].dataVencimento}`;
        } else {
            retorno = mensagem.idGruNossoNumero;
        }
    } else if (mensagem.idGruNossoNumero === undefined && mensagem.tipoMensagem === 12) {
        retorno = PAGAMENTO_GRU_FORA_COMPREV;
    }
    return retorno;
};

const contarNumeroMensagensContestacao = (tipo, mensagens) => {
    let cont = 0;
    mensagens.forEach((item) => {
        if (item.tipoMensagem === tipo) {
            cont += 1;
        }
    });
    return cont;
}

const obterMensagem = (tipo, ehSistema, mensagens) => {
    let retorno = '';
    let contadorMensagemTipo2 = 0;
    let contadorMensagemTipo1 = 0;

    if (tipo === 8) {
        contadorMensagemTipo1 = contarNumeroMensagensContestacao(1, mensagens);
        contadorMensagemTipo2 = contarNumeroMensagensContestacao(2, mensagens);
        if (contadorMensagemTipo1 > 1 || contadorMensagemTipo2 > 1) {
            retorno = 'Pagamento reprovado automaticamente por falta de aprovação';
        }
    } else {
        if (ehSistema) {
            retorno = obterTipoMensagem(tipo).msgSistema;
        } else {
            retorno = obterTipoMensagem(tipo).descricaoMotivo;
        }
    }
    return retorno;
}

export const Mensagem = (props) => {
    const mensagem = props.mensagem;
    let tipo = props.mensagem.tipoMensagem;

    const ehContestacao = (tipo === 1 || tipo === 2);
    const ehContestacaoExtraordinaria = (tipo === 16);
    const ehDefesaExtraordinaria = (tipo === 15);
    const ehDefesa = (tipo === 3 || tipo === 4 || tipo === 5 || tipo === 9 || tipo === 12 || tipo === 15);
    // const ehTermino = (tipo === 6 || tipo === 7 || tipo === 8);
    const ehSistema = (props.mensagem.tipoEmissor === 3);

    /*define a margem de acordo o tipo de mensagem*/
    let margin = '0 5%'; /*margim de termino*/
    if(ehContestacao || ehContestacaoExtraordinaria || ehDefesaExtraordinaria) {margin = '0 20% 0 0'};
    if(ehDefesa) {margin = '0 0 0 20%'};

    /*define titulo painel*/
    let tituloPainel = "Conclusão da análise"; /*texto de termino da análise*/
    if(ehContestacao) {tituloPainel = 'Contestação'};
    if(ehDefesa) {tituloPainel = 'Defesa'};
    if(ehContestacaoExtraordinaria) {tituloPainel = 'Contestação Extraordinária'};
    if(ehDefesaExtraordinaria) {tituloPainel = 'Defesa Extraordinária'};
    tituloPainel = tituloPainel + ' - ' + props.mensagem.dataMensagemFormatada;

    /* Motivo do tipo da mensagem */
    let motivo = obterTipoMensagem(tipo).motivo;
    // let descricaoMotivo = ehSistema ? obterTipoMensagem(tipo).msgSistema : obterTipoMensagem(tipo).descricaoMotivo;
    let descricaoMotivo = obterMensagem(tipo, ehSistema, props.controlePagamento.mensagens);

    /*Mensagem de rejeição RGPS*/
    if(!ehSistema && tipo===7 && props.mensagem.tipoEmissor===2){
        descricaoMotivo = 'O INSS informou pagamento rejeitado por divergência de dados bancários.'
    }

    return(
        <div style={{margin: margin, backgroundColor: 'white'}}>
            <DtpPanel title={tituloPainel} >
            <div style={{float: 'right', color: 'white'}}>{props.mensagem.idMensagem}</div>
            {/*Motivo e descrição da contestacao*/}    
            <div className="row" style={rowStyle}>
                <SimpleGrid>
                    <Grid cols="12 12 12 12">
                        <span>{textoDestaque(motivo)}</span>
                    </Grid>
                    <Grid cols="12 12 12 12">
                        <span>{descricaoMotivo}</span>
                    </Grid>
                </SimpleGrid>
            </div>

            {(!ehSistema || (!ehSistema && tipo !== 7) ) && 
            <React.Fragment>
                {/*GRU */}
                {tipo === 12 &&
                    <h3 className="dtp-datagrid-header" style={{fontSize:'16px',fontWeight: '600', color: '#44707B', marginRight: "30px"}}>Opção de pagamento</h3>
                }
                {tipo === 12 &&
                <div className="row" style={rowStyle}>
                    <SimpleGrid>
                        <Grid cols="12">
                            <span>{(montarTituloGru(mensagem, props.controlePagamento.grusTO))}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </Grid>            
                    </SimpleGrid>
                </div>
                }
                {/*Texto do analista */}
                <h3 className="dtp-datagrid-header" style={{fontSize:'16px',fontWeight: '600', color: '#44707B', marginRight: "30px"}}>Observação do analista</h3>
                <div className="row" style={rowStyle}>
                <SimpleGrid>
                    <Grid cols="12 12 12 12">
                        <span>{mensagem.textoMensagem}</span>
                    </Grid>           
                </SimpleGrid>
                </div>

                {/*Valor Parcial */}
                {mensagem.valorParcial &&
                    <h3 className="dtp-datagrid-header" style={{fontSize:'16px',fontWeight: '600', color: '#44707B', marginRight: "30px"}}>Valor parcial informado</h3>
                }
                {mensagem.valorParcial &&
                <div className="row" style={rowStyle}>
                    <SimpleGrid>
                        <Grid cols="12 12 12 12">
                            <span>{textoDestaque(formatarValor(mensagem.valorParcial))}</span>
                        </Grid>           
                    </SimpleGrid>
                </div>
                }

                {/*Data do pagamento */}
                {mensagem.dataPagamento &&
                <div className="row" style={rowStyle}>
                    <SimpleGrid>
                        <Grid cols="12 12 12 12">
                            <span>{'Data do pagamento do valor total: '}{textoDestaque(mensagem.dataPagamento)}</span>
                        </Grid>           
                    </SimpleGrid>
                </div>
                }

                {/*Valor Atualizado */}
                {[9, 10].includes(tipo) ?
                    <h3 className="dtp-datagrid-header" style={{fontSize:'16px',fontWeight: '600', color: '#44707B', marginRight: "30px"}}>Novo valor de cobrança</h3>
                : '' }
                {([9, 10].includes(tipo)) ?
                    <div className="row" style={rowStyle}>
                        <SimpleGrid>
                            <Grid cols="12">
                                <span>{formatarValor(mensagem.valorCobrancaAtualizado)}</span>
                            </Grid>
                        </SimpleGrid>                        
                    </div>
                : '' }

                {/*Label Não reconheco o valor da cobranca */}
                {((9 === tipo) && ((mensagem.valorCobrancaAtualizado === null || mensagem.valorCobrancaAtualizado === '') || (mensagem.valorCobrancaAtualizado === 0))) ?
                    <div className="row" style={rowStyle}>
                        <SimpleGrid>
                            <Grid cols="12">
                                <span>{textoDestaque('Não reconheço esse valor')}</span>
                            </Grid>
                        </SimpleGrid>
                    </div>
                : '' }
                
                {/*Label Cancelar a cobranca */}
                {((10 === tipo) && (mensagem.valorCobrancaAtualizado === null || mensagem.valorCobrancaAtualizado === '' || mensagem.valorCobrancaAtualizado === 0)) ?
                    <div className="row" style={rowStyle}>
                        <SimpleGrid>
                            <Grid cols="12">
                                <span>{textoDestaque('Cobrança cancelada')}</span>
                            </Grid>
                        </SimpleGrid>
                    </div>
                : '' }

                {/*Valor Pago */}
                {mensagem.valorJuros ?
                <div className="row" style={rowStyle}>
                    <SimpleGrid>
                        <Grid cols="12">
                            <span>{'Valor total: '}{textoDestaque(formatarValor(props.valorCompensacao + mensagem.valorMulta + mensagem.valorJuros))}&nbsp;&nbsp;&nbsp;&nbsp;
                            {'(multa: ' + formatarValor(mensagem.valorMulta) + '  + juros: ' + formatarValor(mensagem.valorJuros) + ")"}
                            </span>
                        </Grid>            
                    </SimpleGrid>
                </div>
                : '' }

                {/*Contato e informações adicionais de contato */}
                <h3 className="dtp-datagrid-header" style={{fontSize:'16px', fontWeight: '600', color: '#44707B',  marginRight: "30px"}}>Informações de contato</h3>
                <div className="row" style={rowStyle}>
                    <SimpleGrid>
                        <Grid cols="12">
                            <span>{'E-mail: '}{mensagem.email}</span>
                        </Grid>    
                        <Grid cols="12">
                            <span>{mensagem.informacoesContato}</span>
                        </Grid>          
                    </SimpleGrid>
                </div> 
                {/*listagem de arquivo */}
                {mensagem.documentosMensagem && <DownloadArquivoMsg arquivos = {mensagem.documentosMensagem}/>}
            </React.Fragment>}
            </DtpPanel>
        </div>
    )
}
Mensagem.propTypes = {
    mensagem: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Mensagem;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/Mensagem.jsx